<template>
	<v-card>
		<v-card-title class="headline grey lighten-2" primary-title>
			Recording
		</v-card-title>
		<v-card-text class="pt-2">
			This video session will be recorded. 
		</v-card-text>
		<v-divider></v-divider>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn color="red" text	@click="declineRecording">
				Decline
			</v-btn>
			<v-btn color="primary" text	@click="allowRecording">
				Agree
			</v-btn>
		</v-card-actions>		
	</v-card>
</template>


<script>
	export default {
		name: "RecordVideo",
		props: ["appointment"],
		data: () => {
			return {
				showDialog: false,
			}
		},
		methods: {
			allowRecording: function(){
				this.showDialog = false;
				this.$store.dispatch( "updateDoc",  {
					doc: "appointments/"+ this.appointment,
					action: "update",
					data: {"recordingPermissionGiven": true}
				})

				this.$emit("allowed");
			},
			declineRecording: function(){
				this.showDialog = false;
				this.$store.dispatch( "updateDoc",  {
					doc: "appointments/"+ this.appointment,
					action: "update",
					data: {"recordingPermissionGiven": false }
				})
				this.$emit("declined")
			}

		} 

	}
</script> 